// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LUX1VmvypN3oy53cPT_P2{background-color:#f6f6f6;background-image:linear-gradient(#f6f6f6, #fff);height:100vh;overflow:auto}\n", "",{"version":3,"sources":["webpack://src/client/pages/me/pages/setting/components/setting-policy/style.module.scss"],"names":[],"mappings":"AACA,uBACI,wBAAyB,CACzB,+CAAgD,CAChD,YAAa,CACb,aAAc","sourcesContent":["\n.SettingPolicy{\n    background-color: #f6f6f6;\n    background-image: linear-gradient(#f6f6f6, #fff);\n    height: 100vh;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SettingPolicy": "LUX1VmvypN3oy53cPT_P2"
};
module.exports = ___CSS_LOADER_EXPORT___;
